<!--
================================================
Vue affichant le formulaire d'inscription
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">
            <signup-comp-b v-if="$route.query.v=='b'"></signup-comp-b> <!-- wip A/B testing -->
            <signup-comp v-else></signup-comp>
        </div>

    </outdoor-layout-comp>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
    import SignupComp from '@/components/SignupComp.vue'
    import SignupCompB from '@/components/SignupCompB.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";

    export default {
        name: 'SignupView',
        components: {
            OutdoorLayoutComp,
            SignupComp, SignupCompB
        },
        mixins: [VueMetaMixin],
        metaInfo(){
            return this.setMeta(this.$t("metaTitleSignupView"),this.$t("metaDescSignupView"))
        },
        methods: {
        },
        created: function () {
        }
        //==========================================================
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
    /*ATTENTION : css non "scoped" s'applique à tout le html*/

    html {
    }

</style>

<style scoped lang="scss">


</style>
